"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/changeHistoryService',["require", "exports", "controllers/changeHistoryController", "routing/mainRouter", "models/userIdentityModel"], function (require, exports, changeHistoryController, mainRouter, userIdentityModel) {
    "use strict";

    var ChangeHistoryService = function () {
        function ChangeHistoryService() {
            _classCallCheck(this, ChangeHistoryService);
        }

        _createClass(ChangeHistoryService, [{
            key: "getPolicyRelatedChanges",
            value: function getPolicyRelatedChanges(policyId) {
                return changeHistoryController.getPolicyRelatedChanges({
                    environmentId: mainRouter.router.environmentId(),
                    insurerId: userIdentityModel.insurerId(),
                    policyId: policyId
                });
            }
        }, {
            key: "getVehicleHistory",
            value: function getVehicleHistory(vehicleId, policyVehicleId) {
                return changeHistoryController.getVehicleHistory({
                    environmentId: mainRouter.router.environmentId(),
                    insurerId: userIdentityModel.insurerId(),
                    vehicleId: vehicleId,
                    policyVehicleId: policyVehicleId
                });
            }
        }, {
            key: "getAddressHistory",
            value: function getAddressHistory(addressId) {
                return changeHistoryController.getAddressHistory({
                    environmentId: mainRouter.router.environmentId(),
                    insurerId: userIdentityModel.insurerId(),
                    addressId: addressId
                });
            }
        }]);

        return ChangeHistoryService;
    }();

    return new ChangeHistoryService();
});
//# sourceMappingURL=changeHistoryService.js.map;
